import useTranslation from 'next-translate/useTranslation';

import styles from './feature-discussion.module.less';

/* eslint-disable-next-line */
export interface FeatureDiscussionProps {}

export function FeatureDiscussion(props: FeatureDiscussionProps) {
  const { t } = useTranslation('common');

  return (
    <div className={styles['container']}>
      <h1>{t('welcome_to_feature_discussion')}</h1>
    </div>
  );
}

export default FeatureDiscussion;
